/** The bar while a session is recorded, at the foot of the app (v1's `RecordingBar`). */
import { useEffect, useState } from "react";

import styles from "./RecordingBar.module.css";
import { useRecorder } from "./store";

function elapsed(seconds: number): string {
  const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  const s = seconds % 60;
  const pad = (n: number) => String(n).padStart(2, "0");
  return h > 0 ? `${h}:${pad(m)}:${pad(s)}` : `${m}:${pad(s)}`;
}

export function RecordingBar() {
  const { recording, saving, failed, stop, cancel } = useRecorder();
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    if (!recording) return;
    const timer = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(timer);
  }, [recording]);
  if (!recording) return null;
  const seconds = Math.max(0, Math.floor((now - recording.startMs) / 1000));
  return (
    <div className={styles.bar} role="status">
      <span className={styles.dot} />
      <span aria-hidden="true">{recording.icon}</span>
      <span className={styles.label}>
        {recording.label}
        {failed && <span className={styles.failed}> — save failed, retry</span>}
      </span>
      <span className={styles.timer}>{elapsed(seconds)}</span>
      <button className={styles.stop} onClick={() => void stop()} disabled={saving}>
        {saving ? "…" : "Stop"}
      </button>
      <button
        className={styles.cancel}
        onClick={cancel}
        disabled={saving}
        aria-label="Cancel recording"
      >
        ✕
      </button>
    </div>
  );
}
